import React from "react";
import { useTranslation } from "react-i18next";
import { LoadingContainer } from "go-core/components/Loading";

interface Props {
	paymentType?: string;
}

const OrderProcessPayment = ({ paymentType }: Props) => {
	const { t } = useTranslation();

	const getLoadingTitle = () => {
		if (paymentType === "BLIK") {
			return t("modules.e_order.field.processing_blik_payment.title");
		}

		return t("modules.e_order.field.processing_payment.title");
	};

	return (
		<div className="order-process-payment" data-testid="e-order-process-payment">
			<div className="w-100">
				<LoadingContainer title={getLoadingTitle()} />
			</div>
		</div>
	);
};

export default OrderProcessPayment;
